import { render, staticRenderFns } from "./NewEntrantsSection.vue?vue&type=template&id=accc1d98&scoped=true"
import script from "./NewEntrantsSection.vue?vue&type=script&lang=js"
export * from "./NewEntrantsSection.vue?vue&type=script&lang=js"
import style0 from "./NewEntrantsSection.vue?vue&type=style&index=0&id=accc1d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accc1d98",
  null
  
)

export default component.exports